let pendingSearch = null;

export function markSearchClicked(user, destination, search) {
    pendingSearch = { user, destination, search };
}

export function consumePendingSearch() {
    const search = pendingSearch;
    pendingSearch = null;
    return search;
}
